import {
  NotificationsListingGetters,
  NotificationsListingActions,
  NotificationsListingMutations
} from '@/app/features/notifications/features/notifications-listing/notifications-listing.keys';
import { notificationsListingService as notificationsService } from '@/app/features/notifications/features/notifications-listing/notifications-listing.service';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import i18n from '@/i18n';

export const getInitialState = () => {
  return {
    notifications: [],
    profileNotifications: [],
    totalUnreadNotifications: null
  };
};

export const notificationsListingStore = {
  state: getInitialState(),
  getters: {
    [NotificationsListingGetters.Notifications]: state => {
      return state.notifications;
    },
    [NotificationsListingGetters.ProfileNotifications]: state => {
      return state.profileNotifications;
    },
    [NotificationsListingGetters.TotalUnreadNotifications]: state => {
      return state.notifications.filter(notification => notification.readAt === null).length;
    },
    [NotificationsListingGetters.ProfileUnreadNotifications]: state => {
      return state.profileNotifications.filter(notification => notification.readAt === null).length;
    },
    [NotificationsListingGetters.IsAnyNotificationChecked]: state => {
      return (
        state.notifications.filter(notification => notification.isSelected === true).length > 0
      );
    },
    [NotificationsListingGetters.SelectedNotifications]: state => param => {
      const selectedNotifications = state.notifications.filter(
        notifications => notifications.isSelected === true
      );
      return selectedNotifications.map(notification => notification[param]);
    },
    [NotificationsListingGetters.AreAllNotificationsSelected]: state => {
      return (
        state.notifications.filter(notification => notification.isSelected === true).length ===
        state.notifications.length
      );
    }
  },
  mutations: {
    [NotificationsListingMutations.RetrieveNotificationsSuccess]: (state, notifications) => {
      const modifiedNotifications = notifications.map(notification => {
        return { ...notification, isSelected: false };
      });

      state.notifications = modifiedNotifications;
    },
    [NotificationsListingMutations.RetrieveProfileNotificationsSuccess]: (state, notifications) => {
      const modifiedNotifications = notifications.map(notification => {
        return { ...notification, isSelected: false };
      });

      state.profileNotifications = modifiedNotifications;
    },
    [NotificationsListingMutations.UpdateSelectedNotifications]: (state, payload) => {
      if (typeof payload === 'number') {
        const idx = state.notifications.findIndex(notification => notification.id === payload);
        const selectedNotification = state.notifications[idx];

        //toggle the 'isSelected' field of chosen notification
        selectedNotification.isSelected = !selectedNotification.isSelected;

        //modify state
        state.notifications[idx] = selectedNotification;
      } else if (typeof payload === 'object') {
        state.notifications.forEach(notification => (notification.isSelected = payload.checked));
      }
    },
    [NotificationsListingMutations.ResetNotificationsState]: state => {
      Object.assign(state, getInitialState());
    }
  },
  actions: {
    [NotificationsListingActions.RetrieveNotifications]: ({ commit, dispatch }) => {
      return notificationsService
        .retrieveNotifications()
        .then(notifications => {
          commit(NotificationsListingMutations.RetrieveNotificationsSuccess, notifications);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('notifications.listing.errors.retrieveNotifications')
          });
        });
    },
    [NotificationsListingActions.RetrieveNotificationsByReferenceNumber]: (
      { commit, dispatch },
      reference_number
    ) => {
      return notificationsService
        .retrieveNotificationsByReferenceNumber(reference_number)
        .then(notifications => {
          commit(NotificationsListingMutations.RetrieveProfileNotificationsSuccess, notifications);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('notifications.listing.errors.retrieveNotifications')
          });
        });
    },
    [NotificationsListingActions.SelectNotification]: ({ commit }, id) => {
      commit(NotificationsListingMutations.UpdateSelectedNotifications, id);
    },
    [NotificationsListingActions.SetInitialNotificationsState]: ({ commit }) => {
      commit(NotificationsListingMutations.ResetNotificationsState);
    },
    [NotificationsListingActions.DeleteSelectedNotifications]: ({ dispatch, getters }) => {
      const selectedNotificationsIds = getters.SelectedNotifications('id');
      return notificationsService
        .deleteNotifications(selectedNotificationsIds)
        .then(() => {
          dispatch(NotificationsListingActions.RetrieveNotifications);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('notifications.listing.errors.updateNotifications')
          });
        });
    },
    [NotificationsListingActions.SetNotificationStatus]: (
      { dispatch, getters },
      { notificationStatus = '', notificationId = '' } = {}
    ) => {
      let status = '';
      const toggledId = [notificationId];
      let selectedNotificationsIds = [];
      status = notificationStatus;
      selectedNotificationsIds = notificationId ? toggledId : getters.SelectedNotifications('id');
      return notificationsService
        .updateNotifications(status, selectedNotificationsIds)
        .then(() => {
          dispatch(NotificationsListingActions.RetrieveNotifications);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('notifications.listing.errors.updateNotifications')
          });
        });
    }
  }
};
